import { render } from "./NeedHelpView.vue?vue&type=template&id=0c53f225"
import script from "./NeedHelpView.vue?vue&type=script&lang=js"
export * from "./NeedHelpView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__